import React from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { useHistory, useParams } from 'react-router-dom';

import { AppHeader, CircularLoader } from 'components';

import ConfirmContext from 'contexts/ConfirmContext';

import { getReceivedBookedAccommodationData } from 'utils/book-accommodation/prepareReceivedBookedAccoomodationData';

import { ACCOMMODATION_BOOKING } from 'graphql/queries/accommodations-bookings';

import BookAccommodation from 'pages/book-accommodation/BookAccommodation';

import useStyles from './styles';

const UpdateAccommodationBookingWrapper = ({ businessOwner }) => {
  const classes = useStyles();
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data } = useQuery(ACCOMMODATION_BOOKING, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      accommodationBookingId: parseInt(id),
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });
  
  if (loading || !businessOwner.selectedBusinessOwner.hasOwnProperty('id')) {
    return (
      <>
        <AppHeader />

        <CircularLoader
          isLoading={true}
          loaderClassName={classes.loaderClassName}
          className={classes.loaderWrapper}
        />
      </>
    );
  }

  if (error || !data.accommodationsBookings.length) {
    confirm({
      title: 'Accommodation booking does not exist!',
      confirmationText: 'Back'
    })
      .then(() => history.push('/booking-list'))
      .catch(() => {});

    return <div style={{ height: '100%' }}>{''}</div>;
  }

  const bookedData = loading
    ? null
    : getReceivedBookedAccommodationData(data.accommodationsBookings[0]);

  return (
    <BookAccommodation
      initialValues={bookedData}
      bookedData={bookedData}
      isUpdate={true}
    />
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(
  mapStateToProps,
  null
)(UpdateAccommodationBookingWrapper);
